<template>
  <div class="account-form form">
    <h2 class="page-subtitle">Sign in Details</h2>

    <b-alert
      :show="user && !user.has_password"
      variant="warning"
      class="account-alert alert__padding alert__border d-flex flex-row align-items-center"
    >
      <div>
        <router-link
          :to="{ name: 'user.change-page', params: { field: 'password' } }"
        >
          <b-img
            :src="require('@/assets/images/alert-info.svg')"
            alt="Alert"
            width="35"
            class="mr-3"
          ></b-img>
        </router-link>
      </div>
      <div>
        <router-link
          :to="{ name: 'user.change-page', params: { field: 'password' } }"
        >
          <p><b>You have registered using your Google Account.</b></p>
          <p>
            For security reasons, please change your password.
          </p>
        </router-link>
      </div>
    </b-alert>

    <b-form-group>
      <custom-input
        type="text"
        :value="user && user.email"
        required
        readonly
        placeholder="Email Address"
      >
        <template slot="link">
          <router-link
            class="change-btn"
            :to="{ name: 'user.change-page', params: { field: 'email' } }"
          >
            Change
          </router-link>
        </template>
      </custom-input>
    </b-form-group>
    <b-form-group>
      <custom-input
        type="text"
        :value="user && user.phone_number"
        required
        readonly
        placeholder="Phone Number"
      >
        <template slot="link">
          <router-link
            class="change-btn"
            :to="{ name: 'user.change-page', params: { field: 'phone' } }"
          >
            Change
          </router-link>
        </template>
      </custom-input>
    </b-form-group>
    <b-form-group>
      <custom-input
        type="password"
        required
        readonly
        value="********"
        placeholder="Password"
      >
        <template slot="link">
          <router-link
            class="change-btn"
            :to="{ name: 'user.change-page', params: { field: 'password' } }"
          >
            Change
          </router-link>
        </template>
      </custom-input>
    </b-form-group>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Account form
 * ==================================================================================
 **/

import { mapState } from 'vuex'
import CustomInput from '@/components/inputs/CustomInput'

export default {
  components: {
    CustomInput
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    change(field) {
      this.$router.push({
        name: 'user.change-page',
        params: {
          field: field
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.account-form {
  .account-alert {
    a {
      font-weight: initial;
      color: var(--brand-warning);
    }

    a:hover,
    a:focus {
      text-decoration: none;
    }
  }
}
</style>
